export default {
  path: '/versionRelease',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'versionRelease',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
